import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import {
  handleGetQuickReport,
  handleGetTransaction,
  handlePostTransaction,
} from "../../services/shef";
import { handleGetOrders } from "../../services/order";
import Footer from "../../frontend/components/Footer";
import { useSelector } from "react-redux";

export const SalesStament = () => {
  const [expandedRow, setExpandedRow] = useState(null);
  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };
  const { authToken, userInfo } = useSelector((state) => state.user);
  const [sales, setSales] = useState(null);
  const [dateRange, setdateRange] = useState({ startDate: "", endDate: "" });
  const [dishName, setDishName] = useState("");
  const [debouncedDishName, setDebouncedDishName] = useState("");
  const [totalEarning, setTotalEarning] = useState(0);
  const [allOrders, setAllOrders] = useState([]); // State to store orders with addresses

  // Fetch orders with addresses
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const ordersRetrieved = await handleGetOrders(authToken, {
          chef_id: userInfo.id,
        });
        setAllOrders(ordersRetrieved || []);
      } catch (error) {
        console.log("Error While Fetching Orders \n", error);
        setAllOrders([]);
      }
    };
    fetchOrders();
  }, [authToken, userInfo.id]);

  const getTrasnsaction = async () => {
  try {
    console.log("Fetching with params:", {
      chef_id: userInfo.id,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
      dishName: debouncedDishName
    });
    
    const res = await handlePostTransaction(
      authToken,
      userInfo.id,
      dateRange.startDate,
      dateRange.endDate,
      debouncedDishName
    );
    
    console.log("API Response:", res);
    console.log("Full response structure:", JSON.stringify(res, null, 2));
    
    // Check different possible response structures
    let data = null;
    if (res?.reports?.original?.reports) {
      data = res.reports.original.reports;
    } else if (res?.reports?.original?.data) {
      data = res.reports.original.data;
    } else if (res?.data) {
      data = res.data;
    } else if (res?.reports) {
      data = res.reports;
    }
    
    console.log("Extracted data:", data);
    console.log("Data type:", typeof data);
    console.log("Data length:", Array.isArray(data) ? data.length : "Not an array");
    
    setSales(data || []);
    
  } catch (error) {
    console.error("Error while fetching transactions:", error);
    console.error("Error details:", error.response?.data || error.message);
    setSales([]);
  }
};
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedDishName(dishName);
    }, 500);
    return () => clearTimeout(handler);
  }, [dishName]);

  useEffect(() => {
    getTrasnsaction();
  }, [dateRange, debouncedDishName]);

  useEffect(() => {
    getTrasnsaction();
  }, []);

  useEffect(() => {
    if (sales) {
      const uniqueOrders = Array.from(
        new Map(sales?.map((order) => [order.order_id, order])).values()
      );
      const totalSaleAmount = uniqueOrders.reduce(
        (sum, order) => sum + order.total_amount,
        0
      );
      setTotalEarning(totalSaleAmount);
    }
  }, [sales]);

  // Function to format address based on address type
  const formatAddress = (addressData) => {
    if (!addressData) return "Address not available";
    
    const { address_type, name, phone } = addressData;
    
    let formattedAddress = "";
    
    if (name) formattedAddress += `${name}`;
    if (phone) formattedAddress += ` (${phone})\n`;
    
    switch (address_type) {
      case "home":
        if (addressData.home_house_no) formattedAddress += `${addressData.home_house_no}, `;
        if (addressData.home_street_address) formattedAddress += `${addressData.home_street_address}, `;
        if (addressData.home_city) formattedAddress += `${addressData.home_city}`;
        if (addressData.home_additional_directions) formattedAddress += `\nAdditional directions: ${addressData.home_additional_directions}`;
        break;
        
      case "office":
        if (addressData.office_company) formattedAddress += `${addressData.office_company}, `;
        if (addressData.office_department) formattedAddress += `${addressData.office_department}\n`;
        if (addressData.office_building_no) formattedAddress += `Building #${addressData.office_building_no}, `;
        if (addressData.office_floor) formattedAddress += `Floor ${addressData.office_floor}\n`;
        if (addressData.office_street_address) formattedAddress += `${addressData.office_street_address}, `;
        if (addressData.office_city) formattedAddress += `${addressData.office_city}`;
        if (addressData.office_additional_directions) formattedAddress += `\nAdditional directions: ${addressData.office_additional_directions}`;
        break;
        
      case "apartment":
        if (addressData.apartment_name) formattedAddress += `${addressData.apartment_name}, `;
        if (addressData.apartment_apartment_no) formattedAddress += `Apartment #${addressData.apartment_apartment_no}, `;
        if (addressData.apartment_floor) formattedAddress += `Floor ${addressData.apartment_floor}\n`;
        if (addressData.apartment_street_address) formattedAddress += `${addressData.apartment_street_address}, `;
        if (addressData.apartment_city) formattedAddress += `${addressData.apartment_city}`;
        if (addressData.apartment_directions) formattedAddress += `\nDirections: ${addressData.apartment_directions}`;
        break;
        
      default:
        formattedAddress = "Address format not recognized";
    }
    
    return formattedAddress;
  };

  // Function to get address by order ID
  const getAddressByOrderId = (orderId) => {
    const order = allOrders.find((order) => order.id === orderId);
    return order && order.order_delivery_address 
      ? formatAddress(order.order_delivery_address) 
      : "Address not found";
  };

  return (
    <>
      <div className="bg-gray-100 min-h-screen">
        <Header />
        <div className="container mx-auto p-6">
          {/* Wallet Card */}
          <div className="bg-gradient-to-br from-red-600 to-red-700 text-white p-8 rounded-2xl shadow-lg text-center mb-10">
            <h1 className="text-2xl font-semibold opacity-90 mb-2">Total Earnings</h1>
            <div className="text-5xl font-bold mb-1">
              {isNaN(parseFloat(totalEarning))
                ? 0
                : parseFloat(totalEarning).toFixed(2)}
            </div>
            <div className="text-sm uppercase tracking-widest opacity-80">Your Earning</div>
          </div>

          {/* Transaction Section */}
          <div className="bg-white rounded-2xl shadow-md overflow-hidden">
            <div className="p-6 border-b">
              <h2 className="text-xl font-semibold text-gray-800 mb-1">Total Transaction History</h2>
              <div className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded inline-block">Tax (10%)</div>
            </div>

            {/* Filter Section */}
            <div className="p-6 bg-gray-50 border-b">
              <h3 className="text-lg font-semibold text-gray-800 mb-6">Select Date</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">From Date</label>
                  <input
                    type="date"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:border-red-600"
                    value={dateRange.startDate || ""}
                    onChange={(e) =>
                      setdateRange({ ...dateRange, startDate: e.target.value })
                    }
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">To Date</label>
                  <input
                    type="date"
                    disabled={!dateRange.startDate}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:border-red-600"
                    value={dateRange.endDate || ""}
                    onChange={(e) =>
                      setdateRange({ ...dateRange, endDate: e.target.value })
                    }
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">Search by Dish Name</label>
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search by dish name"
                      value={dishName || ""}
                      onChange={(e) => setDishName(e.target.value)}
                      className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:border-red-600"
                    />
                    <span className="absolute inset-y-0 right-3 flex items-center text-gray-400">🔍</span>
                  </div>
                </div>
                <div className="flex items-end">
                  <button
                    className="w-full px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                    onClick={() => {
                      setdateRange({ startDate: "", endDate: "" });
                      setDishName("");
                    }}
                  >
                    Clear Filters
                  </button>
                </div>
              </div>
            </div>

            {/* Table Section */}
            <div className="overflow-x-auto">
  <table className="min-w-full text-left">
    <thead className="bg-gray-100">
      <tr>
        <th className="px-6 py-4 text-sm font-medium text-gray-600 uppercase">Order ID</th>
        <th className="px-6 py-4 text-sm font-medium text-gray-600 uppercase">Customer Name</th>
        <th className="px-6 py-4 text-sm font-medium text-gray-600 uppercase">Order Date</th>
        <th className="px-6 py-4 text-sm font-medium text-gray-600 uppercase">Delivery Date</th>
        <th className="px-6 py-4 text-sm font-medium text-gray-600 uppercase">Total Amount</th>
        <th className="px-6 py-4 text-sm font-medium text-gray-600 uppercase">Commission</th>
        <th className="px-6 py-4 text-sm font-medium text-gray-600 uppercase">Delivery</th>
        <th className="px-6 py-4 text-sm font-medium text-gray-600 uppercase">Discount</th>
        <th className="px-6 py-4 text-sm font-medium text-gray-600 uppercase">Net Income</th>
        {/* ✅ New Address Column */}
        <th className="px-6 py-4 text-sm font-medium text-gray-600 uppercase">Address</th>
        <th className="px-6 py-4"></th>
      </tr>
    </thead>
    <tbody className="divide-y divide-gray-200">
      {sales?.map((val, index) => {
        const address = getAddressByOrderId(val.order_id); // get formatted address
        return (
          <React.Fragment key={index}>
            <tr className="hover:bg-gray-50">
              <td className="px-6 py-4 font-semibold text-red-600">#{val.order_id}</td>
              <td className="px-6 py-4 font-medium text-gray-800">{val.user_name}</td>
              <td className="px-6 py-4 text-sm text-gray-500">{val.order_date}</td>
              <td className="px-6 py-4 text-sm text-gray-500">{val.delivery_time}</td>
              <td className="px-6 py-4 font-semibold text-green-600">{val.net_total_amount}</td>
              <td className="px-6 py-4 text-red-600 font-semibold">{val.commission_received}</td>
              <td className="px-6 py-4 text-sm">{val.delivery_charges}</td>
              <td className="px-6 py-4 text-sm">{val.discount_price}</td>
              <td className="px-6 py-4 font-semibold">{val.total_amount}</td>
              {/* ✅ Address Cell */}
              <td className="px-6 py-4 text-sm whitespace-pre-line">{address}</td>
              <td className="px-6 py-4">
                <button
                  className="text-purple-600 hover:text-purple-800 font-medium"
                  onClick={() => toggleRow(index)}
                >
                  {expandedRow === index ? "Show Less" : "Show More"}
                </button>
              </td>
            </tr>

            {expandedRow === index && (
              <tr>
                <td colSpan="11" className="px-6 py-4 bg-gray-50">
                  <table className="w-full text-sm text-gray-700">
                    <thead>
                      <tr className="border-b">
                        <th className="py-2">Dish Name</th>
                        <th className="py-2">Quantity</th>
                        <th className="py-2">Sale Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {val.reports.map((report, i) => (
                        <tr key={i} className="border-b">
                          <td className="py-1">{report.dish_name}</td>
                          <td className="py-1">{report.quantity}</td>
                          <td className="py-1">{report.sale_amount}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </td>
              </tr>
            )}
          </React.Fragment>
        );
      })}
    </tbody>
  </table>
</div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default SalesStament;